import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const LoginPage = lazy(() => import('../pages/login/page'));
const HomePage = lazy(() => import('../pages/home/page'));
const LancamentosPage = lazy(() => import('../pages/lancamentos/page'));
const ColonosPage = lazy(() => import('../pages/colonos/page'));
const RelatorioPage = lazy(() => import('../pages/relatorio/page'));
const PlantacoesPage = lazy(() => import('../pages/plantacoes/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0A0E12] via-[#1A1E23] to-[#0F1419]">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-[#39FF14] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-[#A8B0BC]">Carregando...</p>
    </div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/login',
    element: (
      <Suspense fallback={<PageLoader />}>
        <LoginPage />
      </Suspense>
    )
  },
  {
    path: '/',
    element: (
      <Suspense fallback={<PageLoader />}>
        <HomePage />
      </Suspense>
    )
  },
  {
    path: '/lancamentos',
    element: (
      <Suspense fallback={<PageLoader />}>
        <LancamentosPage />
      </Suspense>
    )
  },
  {
    path: '/colonos',
    element: (
      <Suspense fallback={<PageLoader />}>
        <ColonosPage />
      </Suspense>
    )
  },
  {
    path: '/relatorio',
    element: (
      <Suspense fallback={<PageLoader />}>
        <RelatorioPage />
      </Suspense>
    )
  },
  {
    path: '/plantacoes',
    element: (
      <Suspense fallback={<PageLoader />}>
        <PlantacoesPage />
      </Suspense>
    )
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<PageLoader />}>
        <NotFound />
      </Suspense>
    )
  }
];

export default routes;
